export default defineNuxtPlugin(() => {
  const { showMessage, showError, showWarning, showInfo } = useToastNotify()

  return {
    provide: {
      showMessage,
      showError,
      showWarning,
      showInfo
    }
  }
})
